import React, { useState } from 'react';
import Grid from 'components/layout/grid';
import ButtonPrimary from 'components/button/button_primary';

function CreateWithTitle({ placeholder, onCreate, onChange }) {
  const [value, setValue] = useState('');

  const handleInputChange = e => {
    const newValue = e.target.value;
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleCreate = () => {
    if (!value) return;
    onCreate(value);
    setValue('');
  };

  return (
    <Grid columns={[5, 1]} gap='sm'>
      <input type='text' value={value} onChange={handleInputChange} placeholder={placeholder} />
      <ButtonPrimary type='button' onClick={handleCreate}>Create</ButtonPrimary>
    </Grid>
  );
}

export default CreateWithTitle;